/**
 * Create markup for React dangerouslySetInnerHTML
 * Read: https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
 *
 * @param text
 * @returns {{__html: *}}
 */

const createMarkup = (html) => ({ __html: html || '' })
export default createMarkup
